export function getAvailableTechsForAssignment(
  locationObjectId: string,
  date: string,
  isRouteOptimized: boolean,
  routeContainsDeliveries: boolean,
  routeContainsInstallations: boolean,
) {
  const isoDate = new Date(date).getTime()
  const url = `${process.env.REACT_APP_ORIGIN}/technicians/available/${locationObjectId}/${isoDate}?isRouteOptimized=${isRouteOptimized}&routeContainsDeliveries=${routeContainsDeliveries}&routeContainsInstallations=${routeContainsInstallations}`

  return {
    method: 'GET',
    url,
  }
}
export function getFirstAvailableApp(zipCode: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/zips/${zipCode}/available-date`,
  }
}
export function getAllSchedules(date: string, locationObjectId: string) {
  const dateToMilliseconds = new Date(date).getTime()
  const location = locationObjectId === 'Default (all)' ? '' : locationObjectId
  let url = `${process.env.REACT_APP_ORIGIN}/scheduling/schedule?date=${dateToMilliseconds}`

  if (locationObjectId !== '') {
    url += `&locationId=${location}`
  }
  return {
    method: 'GET',
    url: url,
  }
}
export function getZipCodeAvailability(zipCode?: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/zips/${zipCode}/availability`,
  }
}
export function isLocationServicedCheck(zipCode: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/zips/${zipCode}/availability`,
  }
}
export function reassignTechnicianToRoute(
  routeObjectId: string,
  technicianId: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/routes/${routeObjectId}/technician`,
    body: technicianId,
  }
}
export function reassignTechnicianToDayPlan(
  dayPlanObjectId: string,
  selectedTechnicianObjectId: string,
  previousTechnicianObjectId: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/day-plan/${dayPlanObjectId}/technician`,
    body: {
      selectedTechnicianObjectId,
      previousTechnicianObjectId,
    },
  }
}

export function setFreeOrderReason(
  orderObjectId: string,
  freeOrderReasonObjectId: string,
) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/free-order-reason/${freeOrderReasonObjectId}`,
  }
}

export function removeFreeOrderReason(orderObjectId: string) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/remove-free-order-reason`,
  }
}
export function toggleTireDisposal(
  orderId: string,
  orderVehicleId: string,
  toggle: boolean,
  disposalQty: number,
) {
  let url = `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/vehicles/${orderVehicleId}/tire-disposal`

  if (disposalQty) {
    url += `?disposalQuantity=${disposalQty}`
  }
  return {
    method: 'POST',
    body: toggle,
    url,
  }
}
